import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { Link, useParams } from 'react-router-dom';

import { BodyWrapper, Header, Loader, MainWrapper, Menu } from '@components';
import { linklistsQuery, siteQuery } from '@queries';

import SiteSidebar from '../components/SiteSidebar/SiteSidebar.jsx';
import { SiteBreadcrumbs } from '../components/SiteBreadcrumbs/SiteBreadcrumbs.jsx';

export const SiteMenus = () => {
  const { t, i18n } = useTranslation();
  const { siteID } = useParams();

  // get site/template
  const { data: siteData, isPending: siteIsPending } = useQuery(
    siteQuery(siteID),
  );

  // get linklists
  const { data: linklistsData, isPending: linklistsIsPending } = useQuery(
    linklistsQuery({
      order_by: 'name',
      site_id: siteID,
    }),
  );

  return (
    <>
      <Header />
      <BodyWrapper>
        <SiteSidebar siteID={siteID} siteData={siteData} />
        <MainWrapper>
          <SiteBreadcrumbs siteData={siteData}>
            <li className="sb-flex">
              <span>{t('Menus')}</span>
            </li>
          </SiteBreadcrumbs>
          <div className="sb-manage-content">
            <div className="sb-manage-content-head">
              <h1>{t('Menus')}</h1>
              <div className="sb-button-list-inline">
                <Link
                  to={`/dashboard/sites/${siteID}/menus/new`}
                  className="sb-btn sb-btn-cancel"
                >
                  Add new
                </Link>
              </div>
            </div>
            {linklistsIsPending && (
              <Loader className="sb-loader sb-loader-large" />
            )}
            {!linklistsIsPending && (
              <div className="sb-content-view-row">
                {linklistsData.objects.map((linklist) => {
                  return (
                    <Menu
                      key={linklist.id}
                      linklist={linklist}
                      path={`/dashboard/sites/${siteID}/menus/${linklist.id}`}
                    />
                  );
                })}
              </div>
            )}
          </div>
        </MainWrapper>
      </BodyWrapper>
    </>
  );
};
